import { useConfiguration } from './useConfiguration'

/**
 * Returns whether Hanna is enabled for the current organization.
 *
 * Hanna is being sunset; Ritter is the one remaining org using it during their
 * migration to David. This hook is the single read site for the gate so when
 * Hanna is fully removed, cleanup is a grep-and-delete on `useHannaEnabled`.
 */
export function useHannaEnabled(): boolean {
  const { configuration } = useConfiguration()
  return configuration?.agents?.hanna?.enabled ?? false
}
